import { GET_CLASSES_LIST, GET_CLASS_APPS, GET_CLASSES_LIST_SUCCESS } from '../constants/category';

export const getClassesList = param => ({
  type: GET_CLASSES_LIST,
  param,
});

export const getClassApps = param => ({
  type: GET_CLASS_APPS,
  param,
});

export const setClassesStatus = data => ({
  type: GET_CLASSES_LIST_SUCCESS,
  data,
});
